import { UserStatus, VerifierStaffWhere } from 'src/api';
import { BusinessRole } from 'src/constants/user';

export const getVerifierStaffListFilterQuery = (): VerifierStaffWhere => ({
  user: {
    status: {
      in: [UserStatus.Active],
    },
  },
  role: {
    in: [BusinessRole.VerifierAdmin],
  },
});
